import React from 'react';
import Login from '../components/organisms/Login';

export default function LoginPage() {
  return <Login />;
}
